import { colors } from '../../../defaultTheme';
const PRIMARY_DESTROY = 'primary-destroy';
const TEXT_DESTROY = 'text-destroy';
export const sharedStyles = `
  height: 48px;
  border-style: solid;
  border-color: transparent;
  border-radius: 6px;
  border-width: 2px;
  padding: 0 16px;
  text-transform: uppercase;
`;
export const getHoverStyles = (
// eslint-disable-next-line @typescript-eslint/no-explicit-any
{ disabled, theme }, role) => `
  &:hover {
    ${!disabled
    ? `
      background-color: ${role === PRIMARY_DESTROY || role === TEXT_DESTROY
        ? colors.darkRed
        : theme.button[role].hover};
    `
    : ''}
  }
`;
export const getActiveStyles = (
// eslint-disable-next-line @typescript-eslint/no-explicit-any
{ disabled, theme }, role) => {
    if (!disabled) {
        return `
      &:after {
        content: '';
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        pointer-events: none;
        background-image: radial-gradient(
          circle,
          ${role === 'primary' ? colors.white : theme.button.background} 10%,
          transparent 10%
        );
        background-repeat: no-repeat;
        background-position: 50%;
        transform: scale(10, 10);
        opacity: 0;
        transition: transform 0.5s, opacity 1s;
      }
      &:active:after {
        transform: scale(0, 0);
        opacity: 0.3;
        transition: 0s;
      }
  `;
    }
    return '';
};
export const getPrimaryStyles = (buttonType, theme, disabled, props) => {
    var _a;
    const primaryButtonBgColor = ((_a = theme.button.primary) === null || _a === void 0 ? void 0 : _a.background) || theme.button.background;
    return `
        background-color: ${buttonType === 'primary' ? primaryButtonBgColor : colors.error};
        ${disabled
        ? `background-color: ${colors.lightGrey};`
        : `color: ${buttonType === 'primary'
            ? theme.button.primary.text
            : colors.white};`}
        border: none;
        ${sharedStyles}
        ${getActiveStyles(props, buttonType === 'primary' ? 'primary' : PRIMARY_DESTROY)}
        ${getHoverStyles(props, buttonType === 'primary' ? 'primary' : PRIMARY_DESTROY)}
      `;
};
export const getTextStyles = (buttonType, theme) => {
    return `
        background: inherit;
        height: 24px;
        border: none;
        padding: 0 8px;
        min-width: 0;
        color: ${buttonType === TEXT_DESTROY ? colors.error : theme.button.text};

        &:hover {
          text-decoration: underline;
        }

        background-color: transparent;
      `;
};
export const getSecondaryAndGhostStyles = (buttonType, theme, disabled, props) => {
    return `
        ${sharedStyles}
        ${getActiveStyles(props, 'secondary')}
        ${getHoverStyles(props, 'secondary')}
        ${buttonType === 'secondary'
        ? `border-color: ${disabled ? colors.mediumGrey : theme.button.background};
              background-color: ${colors.white};`
        : `background: inherit;
               background-color: transparent;`}
        `;
};
//# sourceMappingURL=helpers.js.map